/** Students PA cover start window: 1 month back, 3 months forward from today. */

function formatLocalIso(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function todayLocalIso() {
  return formatLocalIso(new Date());
}

export function addMonthsLocalIso(baseIso, months) {
  const [y, m, d] = baseIso.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  date.setMonth(date.getMonth() + months);
  return formatLocalIso(date);
}

export function getPaCoverStartMinDate() {
  return addMonthsLocalIso(todayLocalIso(), -1);
}

export function getPaCoverStartMaxDate() {
  return addMonthsLocalIso(todayLocalIso(), 3);
}

export function getDefaultPaCoverStartDate() {
  return todayLocalIso();
}

export function isPaCoverStartDateValid(dateStr) {
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;
  return dateStr >= getPaCoverStartMinDate() && dateStr <= getPaCoverStartMaxDate();
}

export function computePaCoverEndDate(startDate, courseDuration) {
  if (!startDate) return '';
  const [y, m, d] = startDate.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  switch (courseDuration) {
    case '3_MONTH':
      date.setMonth(date.getMonth() + 3);
      break;
    case '6_MONTH':
      date.setMonth(date.getMonth() + 6);
      break;
    case '1_YEAR':
    default:
      date.setFullYear(date.getFullYear() + 1);
      break;
  }
  return formatLocalIso(date);
}

export function formatPaCoverDateDisplay(iso) {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${Number(d)} ${months[Number(m) - 1]} ${y}`;
}
